import React from "react";
import {
  Text,
  View,
  ActivityIndicator,
  TextInput,
  Switch,
  StyleSheet,
  ScrollView,
  Platform,
  TouchableOpacity,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { filterSites, attachSite, setLoading } from "../redux/actions/customer";
import MenuButton from "../components/MenuButton";
import WebHeading from "../components/WebHeading";
import { RepositStyles, RepositColours } from "../utils/styles";

import goTo from "../utils/goTo";
import storage from "../utils/storage";
import * as boxActions from "../redux/actions/box";

const ChevRight = (
  <Icon
    name="chevron-right"
    size={20}
    color="#CECED2"
    style={{ marginRight: 20 }}
  />
);

const mapStateToProps = (state) => ({
  customer: state.customer,
  rp115sPermitted: state.box.rp115sPermitted,
  permissions: state.user.permissions,
});

const mapDispatchToProps = (dispatch) => {
  return {
    customerActions: bindActionCreators(
      {
        filterSites,
        attachSite,
        setLoading,
      },
      dispatch
    ),
    boxActions: bindActionCreators(boxActions, dispatch),
  };
};

const formatDistance = (distance) => {
  if (distance > 1000) {
    return Math.trunc(distance / 1000) + "km";
  }
  return Math.trunc(distance) + "m";
};

const styles = StyleSheet.create({
  wrapper: { backgroundColor: "white", flex: 1 },
  heading: {
    marginHorizontal: 20,
  },
  headingText: { fontSize: 24, textAlign: "center", fontWeight: "300" },
  addressBox: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#C8C7CC",
  },
  addressHeader: {
    marginHorizontal: 20,
    backgroundColor: "grey",
  },
  addressText: {
    marginHorizontal: 10,
    marginVertical: 2,
    lineHeight: 25,
    fontWeight: "300",
  },
  text: {
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 10,
  },
  paraText: {
    textAlign: "left",
    fontSize: 18,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 30,
    marginTop: 20,
  },
  textInput: {
    fontSize: 16,
    borderRadius: 4,
    height: Platform.OS === "android" ? 40 : 25,
    textAlign: "center",
    backgroundColor: "white",
  },
  textInputWrapper: {
    alignItems: "stretch",
  },
  textInputContainer: {
    marginVertical: 10,
    marginHorizontal: 8,
    borderBottomWidth: Platform.OS === "android" ? 0 : 1,
    borderBottomColor: "#D2D2D2",
  },
  bodyText: {
    marginTop: 10,
  },
});

const AddressListItem = ({ item, onPress }) => {
  return (
    <View style={styles.addressBox}>
      <TouchableOpacity onPress={() => onPress(item.id)}>
        <View
          style={{
            marginVertical: 20,
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <View>
            <Text
              style={{
                ...RepositStyles.paragraphText,
                marginHorizontal: 20,
                fontWeight: "bold",
              }}
            >
              {item.display_address_line_1 + "\n" + item.display_address_line_2}
            </Text>
            {item.distance_metres && (
              <Text
                style={{
                  ...RepositStyles.paragraphText,
                  color: "#BBBBBB",
                  marginHorizontal: 20,
                  marginTop: 3,
                }}
              >
                {formatDistance(item.distance_metres) + " away"}
              </Text>
            )}
          </View>
          <View>{ChevRight}</View>
        </View>
      </TouchableOpacity>
    </View>
  );
};

class ManualAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: true,
      filter: "",
      page: 1, // Note: Page handling is not yet done, but their result should be in the first 100 records
    };
  }

  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "New Setup",
  };

  loadSites = () => {
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }

    // We do a half second debounce here to catch quickly paging through pages and quickly toggling filters.
    this.refreshTimeout = setTimeout(() => {
      this.props.customerActions.setLoading();
      const limit = 100;
      const offset = limit * (this.state.page - 1);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.props.customerActions.filterSites(
            this.state.filter,
            this.state.checked,
            position.coords.latitude,
            position.coords.longitude,
            limit,
            offset
          );
        },
        (error) => {
          this.props.customerActions.filterSites(
            this.state.filter,
            this.state.checked,
            null,
            null,
            limit,
            offset
          );
        }
      );
    }, 500);
  };

  componentDidMount() {
    this.loadSites();
  }

  componentWillUpdate = (nextProps, nextState) => {
    if (
      this.state.filter !== nextState.filter ||
      this.state.checked !== nextState.checked
    ) {
      this.loadSites();
    }
  };

  next = () => {
    const { rp115sPermitted } = this.props;

    if (rp115sPermitted === null) {
      storage
        .load({ key: "rp115sPermitted" })
        .then((ret) => {
          this.props.boxActions.insertRp115sPermitted(ret);
          goTo(this.props.navigation, ret ? "KitNumber" : "EdmiSerial");
        })
        .catch((err) => {
          goTo(this.props.navigation, "KitNumber");
        });
    } else {
      goTo(this.props.navigation, rp115sPermitted ? "KitNumber" : "EdmiSerial");
    }
  };

  attachAndNext = (siteId, rp115sPermitted) => {
    this.props.customerActions.attachSite(siteId);
    this.next();
  };

  render() {
    const allSites = this.props.customer.sites;
    return (
      <View style={styles.wrapper}>
        <WebHeading title="New Setup" />
        <View
          style={{
            flex: 1,
            alignItems: "stretch",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <View style={{ flex: 1, maxWidth: 850, alignItems: "stretch" }}>
            <View style={{ flex: 1 }}>
              <View style={{ backgroundColor: "#EFEFF4" }}>
                <Text
                  style={{ ...RepositStyles.headerText, marginVertical: 20 }}
                >
                  Customer Address
                </Text>
              </View>
              <View
                style={{ backgroundColor: "#CBCBD3", justifyContent: "center" }}
              >
                <View
                  style={{
                    ...styles.textInputWrapper,
                    backgroundColor: "#CBCBD3",
                  }}
                >
                  <View style={styles.textInputContainer}>
                    <TextInput
                      style={styles.textInput}
                      autoCorrect={false}
                      placeholder={"Search Address"}
                      onChangeText={(text) => this.setState({ filter: text })}
                    />
                  </View>
                </View>
              </View>
              {this.props.customer.loadingSites || this.props.customer.error ? (
                <View
                  style={{
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {this.props.customer.error ? (
                    <Text style={{ ...styles.text, marginVertical: 20 }}>
                      {this.props.customer.error}
                    </Text>
                  ) : (
                    <View>
                      <ActivityIndicator size="large" />
                      <Text style={{ ...styles.text, marginVertical: 20 }}>
                        Loading customer locations
                      </Text>
                    </View>
                  )}
                </View>
              ) : (
                <ScrollView>
                  {allSites.map((item) => (
                    <AddressListItem
                      key={item.id}
                      item={item}
                      onPress={this.attachAndNext}
                    />
                  ))}
                </ScrollView>
              )}
              <View
                style={{
                  borderTopWidth: 2,
                  borderTopColor: "#C8C7CC",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    marginVertical: 15,
                  }}
                >
                  <Switch
                    value={this.state.checked}
                    onValueChange={() =>
                      this.setState({ checked: !this.state.checked })
                    }
                    activeTrackColor={RepositColours.blue}
                    onTintColor={RepositColours.blue}
                  />
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      marginHorizontal: 10,
                    }}
                    onPress={() => {
                      this.setState({ checked: !this.state.checked });
                    }}
                  >
                    Show only addresses waiting for installation
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </View>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManualAddress);



// WEBPACK FOOTER //
// ./src/containers/ManualAddress.js